<template>
<div>

<!-- attributes-->	
<template v-for="attribute in customattributes">
	  <template v-if="attribute.supplierattributes.length">	  
	  <template v-if="attribute.type=='string'">
	    <template v-for="translation in attribute.translations">
	      <ClickEditInputText v-show="translation.language_id == $store.state.auth.user.preflang_id" :title="translation.translation" :value="attribute.supplierattributes[0].attibutetextval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)"></ClickEditInputText>
	    </template>
	    
	  </template>

	  <template v-if="attribute.type=='number'">
	    <template v-for="translation in attribute.translations">
	    <ClickEditNumber v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="translation.translation" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)" />
	    </template>
	  </template>

	  <template v-if="attribute.type=='boolean'">
	    <template v-for="translation in attribute.translations">
	    <ClickEditSwitch  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="translation.translation" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)" />
	    </template>	    
	  </template>

	  <template v-if="attribute.type=='categorised'">
	    <template v-for="translation in attribute.translations">
	    <ClickEditCategory  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :allcategories="attribute.categories" :title="translation.translation" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)" />
	    </template>
	  </template>

	  <template v-if="attribute.type=='cascadecategorised'">
	    <template v-for="translation in attribute.translations">
	    <ClickEditCascadeCategory  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :allcategories="attribute.categories" :title="translation.translation" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)" />
	    </template>
	  </template>





	  <template v-if="attribute.type=='select'">
	    <template v-for="translation in attribute.translations">
	    <ClickEditSelect  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="translation.translation" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged($event,attribute.supplierattributes[0].supplier_id)" valkey="languages" :options="attribute.options"  :read_only="!attribute.supplier_can_edit" :color_selector="true"/>
	    </template>
	    
	  </template>

	</template>
	</template>
<!-- attributes-->	

<!-- address-->	
<template v-if="branditem.brand.ask_suppliers_for_address">

<ClickEditSelect   :title="$store.state.languages.lang_phrases.ulke" :value="branditem.supplier.location.country_id" valkey="country_id" @dataChanged="addressChanged($event,branditem.supplier.id)"  :options="countries" :filter="true"  :color_selector="false" />

<template v-if="getcity">
<ClickEditSelect   :title="$store.state.languages.lang_phrases.sehir" :value="branditem.supplier.location.city_id" valkey="city_id" @dataChanged="addressChanged($event,branditem.supplier.id)"  :options="cities" :filter="true"  :color_selector="false" />	
</template>


<ClickEditInputText  :title="$store.state.languages.lang_phrases.adres" :value="branditem.supplier.location.address" valkey="address" @dataChanged="addressChanged($event,branditem.supplier.id)"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.posta_kodu" :value="branditem.supplier.location.zipcode" valkey="zipcode" @dataChanged="addressChanged($event,branditem.supplier.id)"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.enlem" :value="branditem.supplier.location.latitude" valkey="latitude" @dataChanged="addressChanged($event,branditem.supplier.id)"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.boylam" :value="branditem.supplier.location.longitude" valkey="longitude" @dataChanged="addressChanged($event,branditem.supplier.id)"></ClickEditInputText>


</template>


<!-- address-->	
</div>
</template>

<script>
export default {

  name: 'SupplierCustomAttributesModalBrand',
  props:["branditem","countries"],
  data () {
    return {    	
    	cities:[],
    }
  },
  computed:{
  	customattributes()
  	{
  		console.log("BRANNDITEM")
  		console.log(this.branditem)
  		if(this.branditem.customattributes && this.branditem.customattributes.length)
  		{
  			let the_arr = this.branditem.customattributes.filter((item)=>{return item.type=="cascadecategorised"})
	  		let the_rest = this.branditem.customattributes.filter((item)=>{return item.type!=="cascadecategorised"})
	  		console.log("the_arr")
	  		console.log(the_arr)
	  		console.log(the_rest)
	  		the_arr = the_arr.concat(the_rest)
	  		return the_arr
  		}
  		else
  		{
  			return []
  		}
  		
  	},
  	getcity()
  	{
  		console.log("getcity")
  		console.log( this.branditem.supplier);
  		if(this.branditem.supplier && this.branditem.supplier.location.country_id)
  		{
  			this.getCities(this.branditem.supplier.location.country_id)
  			return true
  		}
  		return false
  	}
  },
  mounted()
  {
  },
  methods:{  	
  	async getCities(country_id)
    {
    	this.cities = await this.generalApiGetWithoutLoader("cities/"+country_id) 
    },    
    attributeChanged(data,supplier_id)
    {
      console.log(data)
      //return false
      let item = this.$store.state.auth.supplieropencuatomattributes
      let formdata = new FormData()
      formdata.append("data",data.value)
      formdata.append("customattribute_id",data.key)
      this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+supplier_id,this.afterdataChanged)
    },    
  	async afterdataChanged(response)
    {
		let supplier_open_custom_attributes = await this.silentApiGet("get_supplier_must_submit_custom_attributes")     
		if(supplier_open_custom_attributes.length)
		{
			this.$store.dispatch('auth/setSupplierHaveOpenCustomAttributes',true) 
			this.$store.dispatch('auth/setSupplierOpenCustomAttributes',supplier_open_custom_attributes) 
		}
		else
		{
			this.$store.dispatch('auth/setSupplierHaveOpenCustomAttributes',false) 
		}            
    },
    addressChanged(data,supplier_id)
    {
    	if(data.key=="country_id")
    	{
    		this.getCities(data.value)
    	}
    	console.log(data)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"supplier/"+supplier_id,this.afterdataChanged)
    },
  },
}
</script>

<style lang="css" >
	.p-cascadeselect-sublist .p-cascadeselect-sublist{
		height: 200px;
		overflow-y: scroll;
	}
</style>